export function isPwaOrTwa() {
  if (typeof window === 'undefined') {
    return false;
  }

  const hasStandaloneNavigator =
    'standalone' in window.navigator && window.navigator.standalone === true;

  const supportsMatchMedia = typeof window.matchMedia === 'function';
  const isStandaloneMode =
    supportsMatchMedia && window.matchMedia('(display-mode: standalone)').matches;
  const isFullscreenMode =
    supportsMatchMedia && window.matchMedia('(display-mode: fullscreen)').matches;
  const isMinimalUiMode =
    supportsMatchMedia && window.matchMedia('(display-mode: minimal-ui)').matches;

  const isTwa = typeof document !== 'undefined' && document.referrer.startsWith('android-app://');

  return hasStandaloneNavigator || isStandaloneMode || isFullscreenMode || isMinimalUiMode || isTwa;
}
